/**
 * Origens válidas para o fluxo de seleção de sensores. Reflete os valores que
 * `SensorAlertSection` injeta no query param `origin` ao redirecionar para
 * `/forecast-charts?sensor_selection=true&origin=...` e que o gateway lê de
 * volta na URL. Tipar centralmente evita typos espalhados como string solta.
 */
export type SensorSelectionOrigin =
  | "alert-edit"
  | "event-edit"
  | "insight-manager"
  | "insight-alerts"
  | "forecast-charts"
  | "event-create"
  | "event-create-suggestion";

/**
 * Origens onde a criação/configuração de alerta de sensor de raio (Spec 043)
 * deve ser bloqueada. Por enquanto, apenas a criação de evento via
 * insight-manager — a feature continua disponível em alertas (`insight-alerts`,
 * `alert-edit`) e na edição de eventos existentes (`event-edit`).
 *
 * Decisão de produto: a criação de eventos com lightning vive na aurora-ui;
 * o legado mantém apenas o fluxo de alertas e edições.
 */
const LIGHTNING_BLOCKED_ORIGINS: ReadonlySet<SensorSelectionOrigin> = new Set([
  "insight-manager",
]);

/**
 * Retorna true quando o fluxo identificado por `origin` pode expor a
 * configuração de raio. Default permissivo para origens desconhecidas/nulas
 * (ex.: deep links externos), preservando o comportamento legado.
 */
export function isLightningAllowedForOrigin(
  origin: SensorSelectionOrigin | string | null | undefined,
): boolean {
  if (!origin) return true;
  return !LIGHTNING_BLOCKED_ORIGINS.has(origin as SensorSelectionOrigin);
}
